import React, { useRef } from 'react'
import { Menu as MenuIcon, Repeat, Activity } from 'react-feather'
import styled from 'styled-components'
import { useOnClickOutside } from 'hooks/useOnClickOutside'
import { ApplicationModal } from 'state/application/actions'
import { useModalOpen, useToggleModal, useActiveNetworkUtils } from 'state/application/hooks'

import { useLocation } from 'react-router-dom'
import { networkPrefix } from 'utils/networkPrefix'
import { MenuItem, ExternalMenu, Divider, KyberNetworkLink } from '../styled'
import ThemeToggle from 'components/ThemeToggle'
import SocialLinks from 'components/SocialLinks'
import Wallet from 'components/Icons/Wallet'
import { addNetworkIdQueryString } from 'utils'

const StyledMenuIcon = styled(MenuIcon)`
  stroke: ${({ theme }) => theme.text};
`

const StyledMenuButton = styled.button`
  border: none;
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.buttonBlack};

  border-radius: 0.25rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    opacity: 0.8;
  }
`

const StyledMenu = styled.div`
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border: none;
  text-align: left;
`

const MenuFlyout = styled.span`
  min-width: 8.125rem;
  background-color: ${({ theme }) => theme.background};
  filter: drop-shadow(rgba(0, 0, 0, 0.36) 0px 4px 12px);
  border-radius: 8px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  position: absolute;
  bottom: 48px;
  right: 0rem;
  z-index: 100;
  width: max-content;
  gap: 20px;
`

export default function Menu(): JSX.Element {
  const node = useRef<HTMLDivElement>(null)
  const open = useModalOpen(ApplicationModal.MENU)
  const toggle = useToggleModal(ApplicationModal.MENU)
  useOnClickOutside(node, open ? toggle : undefined)
  const { pathname } = useLocation()
  const { networkInfo, isAllChain } = useActiveNetworkUtils()

  return (
    <StyledMenu ref={node}>
      <StyledMenuButton onClick={toggle}>
        <StyledMenuIcon />
      </StyledMenuButton>

      {open && (
        <MenuFlyout>
          {!isAllChain && (
            <>
              <MenuItem to={networkPrefix(networkInfo) + 'accounts'} isActive={pathname.includes('account')}>
                <Wallet />
                Wallet Analytics
              </MenuItem>
              <Divider />
            </>
          )}

          <ExternalMenu
            href={addNetworkIdQueryString(process.env.REACT_APP_DMM_SWAP_URL || 'https://lyfebloc.com/', networkInfo)}
          >
            <Repeat size={16} />
            Swap
          </ExternalMenu>

          <ExternalMenu href="https://markets.lyfebloc.com/">
            <Activity size={16} />
            Lyfebloc Markets
          </ExternalMenu>

          <Divider />

          <div>
            <ThemeToggle />
            <SocialLinks />
            <KyberNetworkLink href="https://lyfeblocnetwork.com/">Lyfebloc Network</KyberNetworkLink>
          </div>
        </MenuFlyout>
      )}
    </StyledMenu>
  )
}
